import { Check } from "lucide-react";
import { DropdownMenuItem } from "@/clientWeb/components/ui/dropdown-menu";

interface DeviceMenuItemProps {
  label: string;
  selected: boolean;
  onSelect: () => void;
}

export function DeviceMenuItem({
  label,
  selected,
  onSelect,
}: DeviceMenuItemProps) {
  return (
    <DropdownMenuItem
      className="flex items-center justify-between gap-3"
      onSelect={() => {
        onSelect();
      }}
    >
      <span className="min-w-0 flex-1 truncate">{label}</span>
      {selected ? <Check className="h-4 w-4 text-emerald-600" /> : <span className="h-4 w-4" />}
    </DropdownMenuItem>
  );
}
